import { useTranslation } from 'react-i18next'

export const Header = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="fw-bold fs-5 lh-base">
        {t('timeTracking.logTimeDrawer.title')}
      </div>
      <div
        className="btn-close cursor-pointer"
        aria-label={t('common.close')}
        onClick={onClose}
      />
    </>
  )
}
